import { gql } from '@apollo/client'

export const SEARCH_VIDEOS_QUERY = gql`
  query SearchTopicsVideos($query: SearchPostsInput!) {
    searchPosts(query: $query) {
      rows
    }
  }
`

export const CREATE_OWNED_TOPIC = gql`
  mutation createOwnedTopic($savedPostSearch: SavedPostSearchInput!) {
    createSavedPostSearch(savedPostSearch: $savedPostSearch) {
      ... on SavedPostSearch {
        id
        name
        query
        filters
      }
      ... on StatusMessage {
        success
        message
      }
    }
  }
`
